import type { Cue } from './parse-vtt';

type TranscribeItem = {
  id: number;
  type: 'pronunciation' | 'punctuation';
  alternatives: [{ confidence: string; content: string }];
  start_time?: string;
  end_time?: string;
};

/**
 * Parsea el JSON crudo de AWS Transcribe y agrupa palabras en cues (estilo karaoke).
 * Ignora puntuación (no tiene timing). Devuelve `[]` si el shape no es válido.
 */
export const parseTranscribeJson = (json: string, wordsPerCue = 2): Cue[] => {
  const data = JSON.parse(json);
  const items = (data?.results?.items ?? []) as TranscribeItem[];
  const words = items.filter(i => i.type === 'pronunciation' && i.start_time && i.end_time);

  const cues: Cue[] = [];
  for (let i = 0; i < words.length; i += wordsPerCue) {
    const group = words.slice(i, i + wordsPerCue);
    cues.push({
      start: parseFloat(group[0].start_time!),
      end: parseFloat(group[group.length - 1].end_time!),
      text: group.map(w => w.alternatives[0].content).join(' ')
    });
  }
  return cues;
};
